import {
  Autocomplete,
  Box,
  Card,
  Chip,
  ListItem,
  Menu,
  Popover,
  SvgIcon,
  Typography,
  styled,
} from '@mui/material';
import { lightPalette, up } from '../../../../theme';

export const classes = {
  root: 'root',
  actionIcons: 'actionIcons',
  editIcon: 'editIcon',
  headerMoreVertIcon: 'headerMoreVertIcon',
  editIconBox: 'editIconBox',
  statusIcon: 'statusIcon',
  statusIconSize: 'statusIconSize',
  tagChip: 'tagChip',
  columnSelectionBox: 'columnSelectionBox',
  documentRowMainBox: 'documentRowMainBox',
  documentNameBox: 'documentNameBox',
  versionNameBox: 'versionNameBox',
  selectOptionsMainBox: 'selectOptionsMainBox',
  selectedOptionsInnerBox: 'selectedOptionsInnerBox',
  editCellTextfield: 'editCellTextfield',
  versionEditCellTextfield: 'versionEditCellTextfield',
  versionRoot: 'versionRoot',
  actionBox: 'actionBox',
  addTagBox: 'addTagBox',
  popOverInnerBox: 'popOverInnerBox',
  agGridBox: 'agGridBox',
  versionAgGridBox: 'versionAgGridBox',
  loaderBox: 'loaderBox',
  mainGridContainer: 'allInvoicesGridContainer',
  mainGridContainerInnerBox: 'allInvoicesGridContainerInnerBox',
  documentRowTypography: 'documentRowTypography',
  documentRowTypographyColor: 'documentRowTypographyColor',
  documentEditCellBox: 'documentEditCellBox',
  failedChipColor: 'failedChipColor',
  completedChipColor: 'completedChipColor',
  inProgressChipColor: 'inProgressChipColor',
  pendingChipColor: 'pendingChipColor',
  popperBox: 'popperBox',
  dateValueBox: 'dateValueBox',
  moreVertIconBadge: 'moreVertIconBadge',
  columnSelectionMenu: 'columnSelectionMenu',
  documentNameOfVersions: 'documentNameOfVersions',
  versionRootMainBox: 'versionRootMainBox',
  selectAllBox: 'selectAllBox',
  documentSelectedTypo: 'documentSelectedTypo',
  tagFilterIcon: 'tagFilterIcon',
  responsiveHeaderBox: 'responsiveHeaderBox',
  selectedDocumentTypo: 'selectedDocumentTypo',
  selectedDocumentBox: 'selectedDocumentBox',
  selectedVersionBox: 'selectedVersionBox',
  invoiceVersionsAgGridStyle: 'invoiceVersionsAgGridStyle',
  editCellActionIcons: 'editCellActionIcons',
  cardComponent: 'cardComponent',
  errorCardComponent: 'errorCardComponent',
  cardHeader: 'cardHeader',
  closeAction: 'closeAction',
  cardContent: 'cardContent',
  subTitle: 'subTitle',
  exportAccountTypography: 'exportAccountTypography',
  formHelperText: 'formHelperText',
  exportButton: 'exportButton',
  exportButtonNewStyle: 'exportButtonNewStyle',
  logoStyle: 'logoStyle',
  GridItemTextfield: 'GridItemTextfield',
  displayNameErrorText: 'displayNameErrorText',
  cardComponentExtraHight: 'cardComponentExtraHight',
  GridItemsTypography: 'GridItemsTypography',
  extraStyleSubTitle: 'extraStyleSubTitle',
  removeMargin: 'removeMargin',
};

export const AuthCardComponent = styled(Card)(({ theme }) => ({
  [`&.${classes.cardComponent}`]: {
    borderRadius: '5px',
    [up('xs')]: {
      width: '295px',
      height: '340px',
    },
    [up('sm')]: {
      width: '320px',
      height: '200px',
    },
    [up('md')]: {
      width: '360px',
      height: '230px',
    },
    [up('lg')]: {
      width: '400px',
      height: '250px',
    },
    [up('xl')]: {
      width: '400px',
      height: '260px',
    },
    [up('xxl')]: {
      width: '420px',
      height: '290px',
    },
  },
  [`&.${classes.cardComponentExtraHight}`]: {
    [up('xs')]: {
      width: '350px',
      height: '310px',
      overflow: 'auto',
    },
    [up('sm')]: {
      width: '400px',
      height: '370px',
      overflow: 'auto',
    },
    [up('md')]: {
      width: '450px',
      height: '390px',
    },
    [up('lg')]: {
      width: '500px',
      height: '430px',
    },
    [up('xl')]: {
      width: '550px',
      height: '470px',
    },
    [up('xxl')]: {
      width: '590px',
      height: '520px',
    },
  },
  [`& .${classes.GridItemsTypography}`]: {
    color: lightPalette.darkPurple.main,
    [up('xs')]: {
      paddingBottom: '3px',
    },
    [up('sm')]: {
      paddingBottom: '4px',
    },
    [up('md')]: {
      paddingBottom: '5px',
    },
    [up('lg')]: {
      paddingBottom: '6px',
    },
    [up('xl')]: {
      paddingBottom: '8px',
    },
    [up('xxl')]: {
      paddingBottom: '10px',
    },
  },
  [`&.${classes.errorCardComponent}`]: {
    borderRadius: '5px',
    [up('xs')]: {
      width: '295px',
      height: '340px',
    },
    [up('sm')]: {
      width: '360px',
      height: '230px',
    },
    [up('md')]: {
      width: '360px',
      height: '250px',
    },
    [up('lg')]: {
      width: '400px',
      height: '270px',
    },
    [up('xl')]: {
      width: '430px',
      height: '290px',
    },
    [up('xxl')]: {
      width: '450px',
      height: '310px',
    },
  },
  [`& .${classes.cardHeader}`]: {
    background: theme.palette.japanBlush.main,
    borderBottom: `1px solid ${theme.palette.lunarBase.lightest}`,
  },
  [`& .${classes.closeAction}`]: {
    cursor: 'pointer',
    [up('xs')]: {
      width: '16px',
      height: '16px',
    },
    [up('sm')]: {
      width: '18px',
      height: '18px',
    },
    [up('md')]: {
      width: '20px',
      height: '20px',
    },
    [up('lg')]: {
      width: '22px',
      height: '22px',
    },
    [up('xl')]: {
      width: '23px',
      height: '23px',
    },
    [up('xxl')]: {
      width: '24px',
      height: '24px',
    },
  },
  [`& .${classes.cardContent}`]: {
    [up('xs')]: {
      margin: '4px 0px 0px',
    },
    [up('sm')]: {
      margin: '4px 2px 0px',
    },
    [up('md')]: {
      margin: '5px 2px 0px',
    },
    [up('lg')]: {
      margin: '10px 5px 0px',
    },
    [up('xl')]: {
      margin: '13px 8px 0px',
    },
    [up('xxl')]: {
      margin: '18px 11px 0px',
    },
  },
  [`& .${classes.subTitle}`]: {
    color: theme.palette.shoeWax.dark,
    [up('xs')]: {
      marginBottom: theme.spacing(1),
    },
    [up('sm')]: {
      marginBottom: theme.spacing(1.3),
    },
    [up('md')]: {
      marginBottom: theme.spacing(1.5),
    },
    [up('lg')]: {
      marginBottom: theme.spacing(1.5),
    },
    [up('xl')]: {
      marginBottom: theme.spacing(2),
    },
    [up('xxl')]: {
      marginBottom: theme.spacing(2.5),
    },
  },
  [`& .${classes.extraStyleSubTitle}`]: {
    marginBottom: theme.spacing(1.5),
    width: '90%',
  },
  [`& .${classes.exportAccountTypography}`]: {
    fontWeight: 500,
    paddingBottom: theme.spacing(0.5),
  },
  [`& .${classes.formHelperText}`]: {
    marginLeft: theme.spacing(1.5),
    color: '#d32f2f',
  },
  [`& .${classes.displayNameErrorText}`]: {
    [up('xs')]: {
      height: '20px',
    },
    [up('sm')]: {
      height: '20px',
    },
    [up('md')]: {
      height: '20px',
    },
    [up('lg')]: {
      height: '20px',
    },
    [up('xl')]: {
      height: '20px',
    },
    [up('xxl')]: {
      height: '20px',
    },
  },
  [`& .${classes.removeMargin}`]: {
    marginLeft: 0,
  },
  [`& .${classes.exportButton}`]: {
    marginTop: theme.spacing(2),
    [up('xs')]: {
      width: '70px',
      height: '25px',
    },
    [up('sm')]: {
      width: '74px',
      height: '24px',
    },
    [up('md')]: {
      width: '70px',
      height: '26px',
    },
    [up('lg')]: {
      width: '80px',
      height: '35px',
    },
    [up('xl')]: {
      width: '85px',
      height: '33px',
    },
    [up('xxl')]: {
      width: '85px',
      height: '35px',
    },
  },
  [`& .${classes.exportButtonNewStyle}`]: {
    marginTop: '35px',
  },
}));

export const AutocompleteListBox = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
});

export const AutocompleteEditDeleteIconBox = styled(Box)({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const EditIconStyle = styled(SvgIcon)({
  fill: 'none',
  marginRight: '5px',
  [up('xs')]: {
    width: '12px',
    height: '12px',
  },
  [up('md')]: {
    width: '14px',
    height: '14px',
  },
  [up('lg')]: {
    width: '16px',
    height: '16px',
  },
});

export const DeleteIconStyle = styled(SvgIcon)(({ theme }) => ({
  fill: 'none',
  color: theme.palette.colorRed.main,
  marginRight: '5px',
  [up('xs')]: {
    width: '12px',
    height: '12px',
  },
  [up('md')]: {
    width: '14px',
    height: '14px',
  },
  [up('lg')]: {
    width: '16px',
    height: '16px',
  },
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  width: '10vw',
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.5)',
  padding: theme.spacing(1),
  borderRadius: 2,
  background: 'rgba(255, 255, 255, 1)',
}));

export const AddTagButtonContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  overflowWrap: 'anywhere',
});

export const ExportDocumentPopover = styled(Popover)({
  top: '2vh',
});

export const ExportDocumentListItem = styled(ListItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    background: theme.palette.primary.dark,
    color: theme.palette.secondaryWhite.main,
  },
  [`& .${classes.logoStyle}`]: {
    width: '24px',
    height: '24px',
  },
}));

export const OriginalFilesTypo = styled(ListItem)(({ theme }) => ({
  color: theme.palette.shoeWax.darker,
  fontWeight: 500,
  marginLeft: '16px',
  [up('xs')]: {
    fontSize: '7px',
  },
  [up('sm')]: {
    fontSize: '7px',
  },
  [up('md')]: {
    fontSize: '9px',
  },
  [up('lg')]: {
    fontSize: '11px',
  },
  [up('xl')]: {
    fontSize: '13px',
  },
  [up('xxl')]: {
    fontSize: '15px',
  },
}));

export const ExportDocumentListItemTypo = styled(ListItem)(({ theme }) => ({
  color: theme.palette.shoeWax.darker,
  fontWeight: 500,
  marginLeft: '16px',
}));

export const TagNameTypography = styled(Typography)(() => ({
  overflowWrap: 'anywhere',
}));

export const SelectColumnMenu = styled(Menu)(() => ({
  height: '45vh',
  position: 'absolute',
  top: '2%',
  left: '-0.4%',
}));

export const CurserPointerBox = styled(Box)(() => ({
  cursor: 'pointer',
}));

export const SelectTagAutoComplete = styled(Autocomplete)({
  [up('xs')]: {
    width: '15vw',
  },
  [up('sm')]: {
    width: '20vw',
  },
  [up('md')]: {
    width: '18vw',
  },
  [up('lg')]: {
    width: '23vw',
  },
  [up('xl')]: {
    width: '18vw',
  },
  [up('xxl')]: {
    width: '20vw',
  },
});

export const AddTagIconBox = styled(Box)({
  marginRight: '8px',
  [up('xs')]: {
    height: '10px',
    width: '10px',
  },
  [up('sm')]: {
    height: '12px',
    width: '12px',
  },
  [up('md')]: {
    height: '14px',
    width: '14px',
  },
  [up('lg')]: {
    height: '16px',
    width: '16px',
  },
  [up('xl')]: {
    height: '18px',
    width: '18px',
  },
  [up('xxl')]: {
    height: '20px',
    width: '20px',
  },
});

export const AddTagPopupContainer = styled(Box)({
  [up('xs')]: {
    padding: '5px',
  },
  [up('sm')]: {
    padding: '5px',
  },
  [up('md')]: {
    padding: '5px',
  },
  [up('lg')]: {
    padding: '6px',
  },
  [up('xl')]: {
    padding: '7px',
  },
  [up('xxl')]: {
    padding: '10px',
  },
});

export const ChipStyled = styled(Chip)(({ theme }) => ({
  border: 'none',
  color: theme.palette.darkPurple.main,
  cursor: 'pointer',
}));

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.actionIcons}`]: {
    marginRight: '1vw',
    cursor: 'pointer',
    [up('xs')]: {
      width: '12',
      height: '12px',
    },
    [up('sm')]: {
      width: '14',
      height: '14px',
    },
    [up('md')]: {
      width: '16',
      height: '16px',
    },
    [up('lg')]: {
      width: '8',
      height: '8px',
    },
    [up('xl')]: {
      width: '20',
      height: '20px',
    },
    [up('xxl')]: {
      width: '22',
      height: '22px',
    },
  },
  [`& .${classes.editIconBox}`]: {
    marginTop: '9px',
  },
  [`& .${classes.documentSelectedTypo}`]: {
    marginRight: '1vw',
  },
  [`& .${classes.selectedDocumentBox}`]: {
    margin: '15px 10px',
    padding: '5px',
    display: 'flex',
    backgroundColor: 'background.paper',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.5)',
  },
  [`& .${classes.selectedVersionBox}`]: {
    margin: '15px 10px',
    padding: 1,
    display: 'flex',
  },
  [`& .${classes.editIcon}`]: {
    cursor: 'pointer',
    fontSize: '10px',
    [up('xs')]: {
      width: '12px',
      height: '12px',
    },
    [up('sm')]: {
      width: '14px',
      height: '14px',
    },
    [up('md')]: {
      width: '16px',
      height: '16px',
    },
    [up('lg')]: {
      width: '10px',
      height: '10px',
    },
    [up('xl')]: {
      width: '20px',
      height: '20px',
    },
    [up('xxl')]: {
      width: '22px',
      height: '22px',
    },
  },
  [`& .${classes.headerMoreVertIcon}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  [`& .${classes.selectedDocumentTypo}`]: {
    marginRight: '1vw',
  },
  [`& .${classes.statusIcon}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.selectAllBox}`]: {
    margin: '15px 10px',
    padding: theme.spacing(1),
    display: 'flex',
    background: 'background.paper',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.5)',
  },
  [`& .${classes.statusIconSize}`]: {
    [up('xs')]: {
      width: '14',
      height: '14px',
    },
    [up('sm')]: {
      width: '16',
      height: '16px',
    },
    [up('md')]: {
      width: '18',
      height: '18px',
    },
    [up('lg')]: {
      width: '20',
      height: '20px',
    },
    [up('xl')]: {
      width: '22',
      height: '22px',
    },
    [up('xxl')]: {
      width: '24',
      height: '24px',
    },
  },
  [`& .${classes.tagChip}`]: {
    border: 'none',
    color: theme.palette.darkPurple.main,
    background: theme.palette.japanBlush.main,
    cursor: 'pointer',
  },
  [`& .${classes.columnSelectionBox}`]: {
    position: 'absolute',
    zIndex: 1000,
    top: '12px',
    right: '0px',
  },
  [`& .${classes.documentRowMainBox}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.documentNameBox}`]: {
    [up('xs')]: {
      width: '14vw',
      marginRight: '2vw',
    },
    [up('sm')]: {
      width: '41vw',
      marginRight: '2vw',
    },
    [up('md')]: {
      width: '30vw',
      marginRight: '2vw',
    },
    [up('lg')]: {
      width: '20vw',
      marginRight: '2vw',
    },
    [up('xl')]: {
      width: '19vw',
      marginRight: '2vw',
    },
    [up('xxl')]: {
      width: '14vw',
      marginRight: '2vw',
    },
  },
  [`& .${classes.selectOptionsMainBox}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  [`& .${classes.selectedOptionsInnerBox}`]: {
    margin: '8px 0px',
    p: 1,
    display: 'flex',
    bgcolor: 'background.paper',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.5)',
  },
  [`& .${classes.editCellTextfield}`]: {
    '& fieldset': {
      border: 'none',
      borderRadius: '5px',
      backgroundColor: theme.palette.secondaryWhite.semiDark,
    },
    '& .MuiInputBase-input:hover + fieldset': {
      border: 'none !important',
    },
    '& .MuiInputBase-input:focus + fieldset': {
      border: 'none !important',
    },
    [up('xs')]: {
      width: '18vw',
    },
    [up('sm')]: {
      width: '45vw',
    },
    [up('md')]: {
      width: '34vw',
    },
    [up('lg')]: {
      width: '24vw',
    },
    [up('xl')]: {
      width: '23vw',
    },
    [up('xxl')]: {
      width: '18vw',
    },
  },
  [`& .${classes.versionRoot}`]: {
    [up('xs')]: {
      height: `calc(100vh - ${theme.spacing(6)});`,
      padding: '20px 14px',
    },
    [up('sm')]: {
      padding: '20px 16px',
    },
    [up('md')]: {
      padding: '23px 18px',
    },
    [up('lg')]: {
      padding: '25px 20px',
    },
    [up('xl')]: {
      padding: '30px 23px',
    },
    [up('xxl')]: {
      padding: '35px 25px',
    },
  },
  [`& .${classes.versionNameBox}`]: {
    [up('xs')]: {
      width: '4vw',
      marginRight: '2vw',
    },
    [up('sm')]: {
      width: '20vw',
      marginRight: '2vw',
    },
    [up('md')]: {
      width: '16vw',
      marginRight: '2vw',
    },
    [up('lg')]: {
      width: '10vw',
      marginRight: '2vw',
    },
    [up('xl')]: {
      width: '9vw',
      marginRight: '2vw',
    },
    [up('xxl')]: {
      width: '7vw',
      marginRight: '2vw',
    },
  },
  [`& .${classes.versionEditCellTextfield}`]: {
    '& fieldset': {
      border: 'none',
      borderRadius: '5px',
      backgroundColor: theme.palette.secondaryWhite.semiDark,
    },
    '& .MuiInputBase-input:hover + fieldset': {
      border: 'none !important',
    },
    '& .MuiInputBase-input:focus + fieldset': {
      border: 'none !important',
    },
    [up('xs')]: {
      width: '7vw',
    },
    [up('sm')]: {
      width: '21vw',
    },
    [up('md')]: {
      width: '19vw',
    },
    [up('lg')]: {
      width: '13vw',
    },
    [up('xl')]: {
      width: '10vw',
    },
    [up('xxl')]: {
      width: '8vw',
    },
  },
  [`& .${classes.actionBox}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.addTagBox}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.popOverInnerBox}`]: {
    [up('xs')]: {
      padding: '5px',
    },
    [up('sm')]: {
      padding: '5px',
    },
    [up('md')]: {
      padding: '5px',
    },
    [up('lg')]: {
      padding: '6px',
    },
    [up('xl')]: {
      padding: '7px',
    },
    [up('xxl')]: {
      padding: '10px',
    },
  },
  [`& .${classes.agGridBox}`]: {
    [up('xs')]: {
      height: '50vh',
    },
    [up('sm')]: {
      height: '55vh',
    },
    [up('md')]: {
      height: '53vh',
    },
    [up('lg')]: {
      height: '55vh',
    },
    [up('xl')]: {
      height: '60vh',
    },
    [up('xxl')]: {
      height: '65vh',
    },
  },
  [`& .${classes.loaderBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [up('xs')]: {
      height: '40vh',
    },
    [up('sm')]: {
      height: '46vh',
    },
    [up('md')]: {
      height: '44vh',
    },
    [up('lg')]: {
      height: '50vh',
    },
    [up('xl')]: {
      height: '50vh',
    },
    [up('xxl')]: {
      height: '66vh',
    },
  },
  [`& .${classes.documentRowTypography}`]: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  [`& .${classes.documentRowTypographyColor}`]: {
    color: theme.palette.lunarBase.main,
  },
  [`& .${classes.documentEditCellBox}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.failedChipColor}`]: {
    background: theme.palette.colorRed.main,
  },
  [`& .${classes.completedChipColor}`]: {
    background: theme.palette.colorGreen.main,
  },
  [`& .${classes.inProgressChipColor}`]: {
    background: theme.palette.lavender.main,
  },
  [`& .${classes.pendingChipColor}`]: {
    background: theme.palette.venetianRed.main,
  },
  [`& .${classes.popperBox}`]: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '10vw',
    boxShadow: `0px 2px 8px ${theme.palette.secondaryBlack.medium}`,
    p: 1,
    borderRadius: 2,
    background: theme.palette.secondaryWhite.main,
  },
  [`& .${classes.dateValueBox}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  [`& .${classes.moreVertIconBadge}`]: {
    '& .MuiBadge-badge': {
      left: -5,
      top: 3,
      backgroundColor: theme.palette.colorRed.main,
      cursor: 'pointer',
    },
  },
  [`& .${classes.columnSelectionMenu}`]: {
    height: '40vh',
    position: 'absolute',
    top: '2%',
    left: '-0.4%',
  },
  [`& .${classes.documentNameOfVersions}`]: {
    color: theme.palette.primary.main,
    width: '50%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'right',
  },
  [`& .${classes.versionRootMainBox}`]: {
    justifyContent: 'space-between',
  },
  [`& .${classes.tagFilterIcon}`]: {
    height: '20px',
  },
  [`& .${classes.responsiveHeaderBox}`]: {
    display: 'flex',
    width: '100%',
  },
  [`& .${classes.invoiceVersionsAgGridStyle}`]: {
    [up('xs')]: {
      height: '40vh',
    },
    [up('sm')]: {
      height: '45vh',
    },
    [up('md')]: {
      height: '45vh',
    },
    [up('lg')]: {
      height: '50vh',
    },
    [up('xl')]: {
      height: '55vh',
    },
    [up('xxl')]: {
      height: '60vh',
    },
  },
  [`& .${classes.editCellActionIcons}`]: {
    padding: '0px, 10px',
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.GridItemTextfield}`]: {
    borderColor: lightPalette.darkPurple.lighter,
    borderRadius: '5px',
    '& .MuiInputBase-input': {
      [up('xs')]: {
        height: '6px',
      },
      [up('sm')]: {
        height: '13px',
      },
      [up('md')]: {
        height: '20px',
      },
      [up('lg')]: {
        height: '25px',
      },
      [up('xl')]: {
        height: '30px',
      },
      [up('xxl')]: {
        height: '45px',
      },
    },
  },
}));
